import {
  FormHelperText,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ContentTitle from "components/common/ContentTitle";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles,
} from "components/request-document/components/Commons";
import CompanyInfoSection from "components/request-document/components/CompanyInfoSection";
import { useExtendsionFormFormA } from "components/smart-visa-extension/useExtendsionForm";
import { openFileById } from "libs/utils/file";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React from "react";
import { useSelector } from "react-redux";
import { selectMasterData } from "redux/modules/masterSlice";
import FileService from "services/FileService";

export default function FromA() {
  const classes = useStyles();

  const { formik, onSaveDraft } = useExtendsionFormFormA();

  const masterData = useSelector(selectMasterData);

  const activitiesConfig = get(masterData, "activitiesConfig", []);
  const assignmentConfig = get(masterData, "assignmentConfig", []);
  const technologyCoreConfig = get(masterData, "technologyCoreConfig", []);
  const technologyEmploymentConfig = get(
    masterData,
    "technologyEmploymentConfig",
    []
  );

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="APPLICATION FOR SMART VISA EXTENSION"
          subTitle="SMART VISA EXTENSION"
        />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    FORM A
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <CompanyInfoSection formik={formik} />

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={6} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Business or products or services description
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="ProductService"
                        value={formik.values.ProductService}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ProductService", formik)}
                        helperText={getErrorMessage("ProductService", formik)}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={7} />
                    <div className={classes.wrapField}>
                      <InputLabel>Major products or services</InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Sale revenue (Approximate in Baht)
                      </InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="MajorService"
                    value={formik.values.MajorService}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("MajorService", formik)}
                    helperText={getErrorMessage("MajorService", formik)}
                    multiline
                    rows={5}
                    rowsMin={5}
                    rowsMax={5}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="SaleRevenune"
                    value={formik.values.SaleRevenune}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("SaleRevenune", formik)}
                    helperText={getErrorMessage("SaleRevenune", formik)}
                    multiline
                    rows={5}
                    rowsMin={5}
                    rowsMax={5}
                  />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={8} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Please choose the targeted industries most relevant to
                        your company’s activities
                      </InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                        style={{ width: 500 }}
                      >
                        <InputLabel>Activities</InputLabel>
                        <Select
                          label="Activities"
                          name="activitiesId"
                          value={formik.values.activitiesId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {activitiesConfig.map((activities) => (
                            <MenuItem
                              key={activities.activitiesId}
                              value={activities.activitiesId}
                            >
                              {activities.activitiesName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={1}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Sub activities</InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                        style={{ width: 350 }}
                      >
                        <InputLabel>Sub activities</InputLabel>
                        <Select
                          label="Sub activities"
                          name="activitiesIdSub"
                          value={formik.values.activitiesIdSub}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {activitiesConfig.map((activities) => (
                            <MenuItem
                              key={activities.activitiesId}
                              value={activities.activitiesId}
                            >
                              {activities.activitiesName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={9} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Manufacturing/Service Process Please provide a
                        processdiagram that explains the manufacturing/service
                        process (additional documents can be attached).
                      </InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRowHead>
                <StyledTableCell colSpan={2} align="center">
                  <InputLabel>Process Diagram</InputLabel>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <InputLabel>Explanation</InputLabel>
                </StyledTableCell>
              </TableRowHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.flexRow}>
                    <InputLabel>File Upload ( PDF, JPG )</InputLabel>
                    <div style={{ width: 18 }} />
                    <UploadButton
                      title={
                        get(formik.values, `ProcessDiagram.FileID`, "")
                          ? "Edit"
                          : "+ Add"
                      }
                      id={`upload-ProcessDiagram`}
                      onChange={async (event) => {
                        try {
                          const response = await FileService.uploadFile({
                            file: event.target.files[0],
                            Status: true,
                          });
                          const fileId = response.results?.fileID;
                          const [filename, ext] =
                            event.target.files[0].name.split(".");

                          formik.setFieldValue(`ProcessDiagram`, {
                            processfileID: fileId,
                            FileID: fileId,
                            filename,
                            ext,
                            Status: true,
                          });
                        } catch (error) {
                          console.log("Upload error", error);
                        }
                      }}
                    />
                    {get(formik.values, `ProcessDiagram.FileID`, "") && (
                      <IconButton
                        style={{ width: 40 }}
                        size="small"
                        onClick={async () => {
                          const processfileID = get(
                            formik.values,
                            `ProcessDiagram.FileID`,
                            ""
                          );

                          openFileById(processfileID);
                        }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                    )}
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="Explanation"
                    value={formik.values.Explanation}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("Explanation", formik)}
                    helperText={getErrorMessage("Explanation", formik)}
                    multiline
                    rows={10}
                  />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={10} />
                    <div className={classes.wrapField}>
                      <InputLabel>Amount of share (Baht)</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="AmountofShare"
                        value={formik.values.AmountofShare}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("AmountofShare", formik)}
                        helperText={getErrorMessage("AmountofShare", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={11} />
                    <div className={classes.wrapField}>
                      <InputLabel>Value per share (Baht)</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="ValuePerShare"
                        value={formik.values.ValuePerShare}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ValuePerShare", formik)}
                        helperText={getErrorMessage("ValuePerShare", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={12} />
                    <div className={classes.wrapField}>
                      <InputLabel>Value per share (Baht)</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="SharesOwned"
                        value={formik.values.SharesOwned}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("SharesOwned", formik)}
                        helperText={getErrorMessage("SharesOwned", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={13} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Please select the core technology used in the production
                        process or services provision
                      </InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("ProcessDiagram", formik)}
                        style={{ width: 650 }}
                      >
                        <InputLabel>
                          Selected the the core technology used in the
                          production process or services provision
                        </InputLabel>
                        <Select
                          label="Selected the the core technology used in the production process or services provision"
                          name="assignmentId"
                          value={formik.values.assignmentId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {assignmentConfig.map((assignment) => (
                            <MenuItem
                              value={assignment.assignmentId}
                              key={assignment.assignmentId}
                            >
                              {assignment.assignmentName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          error={isError("ProcessDiagram", formik)}
                        >
                          {getErrorMessage("ProcessDiagram", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={14} />
                    <div className={classes.wrapField}>
                      <InputLabel>Acquisition of core technology</InputLabel>
                      <FormGroup row>
                        {technologyCoreConfig.map((technologyCore) => (
                          <FormControlLabel
                            key={technologyCore.technologyCoreID}
                            control={
                              <StyleCheckbox
                                name={technologyCore.technologyCoreName}
                                value={technologyCore.technologyCoreID}
                                checked={
                                  formik.values.technologyCore ===
                                  technologyCore.technologyCoreID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "technologyCore",
                                    technologyCore.technologyCoreID
                                  );
                                }}
                              />
                            }
                            label={technologyCore.technologyCoreName}
                          />
                        ))}
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Please explain</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="technologyCoreExplain"
                        value={formik.values.technologyCoreExplain}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("technologyCoreExplain", formik)}
                        helperText={getErrorMessage(
                          "technologyCoreExplain",
                          formik
                        )}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={15} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Objective of technology employment
                      </InputLabel>
                      <FormGroup row>
                        {technologyEmploymentConfig.map(
                          (technologyEmployment) => (
                            <FormControlLabel
                              key={technologyEmployment.technologyEmploymentID}
                              control={
                                <StyleCheckbox
                                  name={
                                    technologyEmployment.technologyEmploymentName
                                  }
                                  value={
                                    technologyEmployment.technologyEmploymentID
                                  }
                                  checked={
                                    formik.values.technologyEmployment ===
                                    technologyEmployment.technologyEmploymentID
                                  }
                                  onClick={() => {
                                    formik.setFieldValue(
                                      "technologyEmployment",
                                      technologyEmployment.technologyEmploymentID
                                    );
                                  }}
                                />
                              }
                              label={
                                technologyEmployment.technologyEmploymentName
                              }
                            />
                          )
                        )}
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Please explain</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="technologyEmploymentExplain"
                        value={formik.values.technologyEmploymentExplain}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("technologyEmploymentExplain", formik)}
                        helperText={getErrorMessage(
                          "technologyEmploymentExplain",
                          formik
                        )}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <div />
            </TableBody>
          </Table>
        </TableContainer>

        <ButtonController
          isExtend
          onClickSaveDraft={() => {
            onSaveDraft();
          }}
        />
      </form>
    </div>
  );
}
